/*URL base para acessar o magic edition */
export const baseUrlDPA = "https://diarioonline.com.br/digital";
export const baseHubDPA = "https://www.diarioonline.com.br/hub/json"